const EnumEtapaConvocacao = {
    CRIADA: 'CRIADA',
    BUSCANDO_FUNCIONARIOS: 'BUSCANDO_FUNCIONARIOS',
    FUNCIONARIOS: 'FUNCIONARIOS',
    CONFIRMACAO: 'CONFIRMACAO',
    SOLICITANDO: 'SOLICITANDO',
    FINALIZADA: 'FINALIZADA'
}

export default EnumEtapaConvocacao;